export class ApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
    readonly field?: string,
  ) {
    super(message);
  }
}

// POST JSON to the API. Errors come back as { error, field? }.
export async function postJson<T>(path: string, body: unknown): Promise<T> {
  let res: Response;
  try {
    res = await fetch(path, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(body),
    });
  } catch {
    throw new ApiError('No connection. Check your signal and try again.', 0);
  }
  const data = (await res.json().catch(() => ({}))) as { error?: string; field?: string };
  if (!res.ok) {
    const fallback =
      res.status === 429
        ? 'Too many attempts. Wait a few minutes and try again.'
        : 'Something went wrong on our side. Please try again.';
    throw new ApiError(data.error || fallback, res.status, data.field);
  }
  return data as T;
}
